import enMessages from '../locales/el_GR.json';

const ElLang = {
  messages: {
    ...enMessages
  },
  locale: 'el-GR',
};
export default ElLang;
